/* eslint-env browser */
/* globals GIG */

'use strict';

const { h, Component } = require('phy');

const notificationComponent = require('../components/notification_component');

class NotificationContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fadeNode: false,
    };
    this.timeout = null;
    this.showGuestCTAWidget = this.showGuestCTAWidget.bind(this);
  }

  showGuestCTAWidget() {
    const { notificationKlass, isLoggedIn, showCTAV1Experience } = this.props;
    if (showCTAV1Experience) return false;
    return !(notificationKlass === '.error' || isLoggedIn);
  }

  componentDidMount() {
    const timeout = this.showGuestCTAWidget() ? 10000 : 3000;
    // if GIG isn't loaded yet
    try {
      GIG.Alerts.init('.promo-code-v2');
    } catch (e) {
      // To something
    }
    this.timeout = setTimeout(() => {
      // if user already closed don't try to close
      if (document.querySelector('.promo-code-v2 .notification')) {
        this.setState({ fadeNode: true });
      }
    }, timeout);
  }

  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  render() {
    return h(notificationComponent, {
      ...this.props,
      ...this.state,
      showGuestCTAWidget: this.showGuestCTAWidget,
    });
  }
}

module.exports = NotificationContainer;
